module.exports = __webpack_public_path__ + "static/media/loginpic4.63116045.jpg";